<doc>
  @desc:   布局 - 头部组件
  @author:  
</doc>
<template>
  <div class="header-wrapper" :class="minWidth?'header-min-width':''">
    <div class="header-content flex flex-align-center">
      <div class="header-logo" @click="goHome()"><img src="/static/images/score66_logo.png" /></div>
      <div class="header-gg login-wrapper-left">
        <template v-if="ListAd.length>0">
          <template v-for="(item, index) in ListAd">
            <div class="ad-box" :class="item.flag ? '' : 'ad-no-icon'" v-if="item.siteId == 103" :key="index">
              <router-link :to="'/gdt?gdtUrl=' + item.url" target="_blank" @click.native="adHit(item.id)"><img :src="item.img" /></router-link>
            </div>
          </template>
        </template>
      </div>
      <!-- <div class="header-search flex flex-align-center">
        <i class="icon-font icon-search"></i>
        <span>Search</span>
      </div> -->
      <div class="login-wrapper flex flex-align-center" v-if="policy">
        <div class="login-info flex flex-align-center" v-if="loginInfoShow">
          <img src="~@/assets/images/avtar.png"/>
          <span>{{ login.nickname }}</span>
        </div>
        <div class="login-btn" @click="showLoginPopup" v-if="!loginInfoShow">{{ langConfig.login[langConfig.curLang]['LOGIN'] }}</div>
        <div class="set-wrapper" :class="popSetting ? 't-seti-show' : ''" @click="setBtn()" ref="setMain" v-if="isSetShowFn()">
          <i class="icon-seti"></i>
        </div>
      </div>
      <div class="pop-setting-wrapper" :class="popSetting ? 'pop-setting-show' : ''" ref="popSetMain" v-if="policy" @click.self="bodyClose()">
        <div class="popNav flex flex-align-center" v-show="screenWidth<= 767 && navTab">
          <template v-for="(item, index) in langConfig.txtLang[langConfig.curLang]['POP_NAV']">
            <span :class="tab==item.id ? 'on' : ''" @click="tabClick(item.id)" :key="index">{{ item.name }}</span>
          </template>
        </div>
        <div class="setting-menu-contant flex flex-v" v-show="screenWidth > 767 || tab == 1">
          <div class="setting-account flex flex-v" v-if="loginInfoShow">
            <button class="setting-account-btn" @click="accountClick()">{{ langConfig.account[langConfig.curLang]['ACCOUNT_INFO'] }}</button>
          </div>

          <div class="setting-mode flex flex-v" v-if="isSetModle('darkSwith')">
            <div class="setting-mode-title flex flex-align-center">
              <i class="icon-font icon-dark"></i>
              <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['DARK_MODE'] }}</span>
              <div class="switch-box">
                <el-switch
                  :active-value="true"
                  :inactive-value="false"
                  v-model="setting.darkSwith"
                  active-color="#09B363"
                  inactive-color="#D9D9D9" 
                  @change="(val) => {
                onChangeSetting(val, 'darkSwith')}"
                  >
                </el-switch>
              </div>
            </div>
          </div>
          <!-- <div class="setting-mode flex flex-v">
            <div class="setting-mode-title flex flex-align-center">
              <i class="icon-font icon-sound"></i>
              <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['SOUND'] }}</span>
              <div class="switch-box">
                <el-switch
                  v-model="setting.soundSwith"
                  active-color="#09B363"
                  inactive-color="#D9D9D9">
                </el-switch>
              </div>
            </div>
          </div> -->
          <div class="setting-mode flex flex-v" v-show="isSetModle('timeZone')">
            <div class="setting-mode-title flex flex-align-center">
              <i class="icon-font icon-time"></i>
              <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['TIME_ZONE'] }}</span>
            </div>
            <div class="setting-mode-content flex flex-v">
              <div class="pickerPlug"> 
                <DasePicker class="dasePickerBox" 
                  ref="DasePicker"
                  :options="pickerList"  
                  @changePicker="changePicker"
                ></DasePicker>
              </div> 
            </div>
          </div>
          <div class="setting-mode flex flex-v" v-if="isSetModle('order')">
            <div class="setting-mode-title flex flex-align-center">
              <i class="icon-font icon-sort"></i>
              <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['ORDER_BY'] }}</span>
            </div>
            <div class="setting-mode-content flex flex-v">
              <el-radio-group v-model="setting.sortRadio" @change="(val) => {
                onChangeSetting(val, 'sortRadio')
              }">
                <el-radio class="sort-radio" :label="1">{{ langConfig.setting[langConfig.curLang]['LEAGUES'] }}</el-radio>
                <el-radio class="sort-radio" :label="2">{{ langConfig.setting[langConfig.curLang]['KICK_OFF'] }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- <div class="setting-mode flex flex-v" v-if="isSetModle('oddsType')">
            <div class="setting-mode-title flex flex-align-center">
              <i class="icon-font icon-type"></i>
              <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['ODDS_TYPES'] }}</span>
            </div>
            <div class="setting-mode-content">
              <div class="setting-odds-type flex flex-pack-justify">
                <span :class="setting.oddsType*1 == (index+1) ? 'sot-is-checked' : ''" v-for="(item, index) in oddTypeArr" @click="onChangeSetting((index+1), 'oddsType')" :key="index">{{ item }}</span>
              </div>
            </div>
          </div> -->
          <div class="setting-mode flex flex-v" v-if="isSetModle('oddsForm')">
            <div class="setting-mode-title flex flex-align-center">
              <i class="icon-font icon-type"></i>
              <span class="mode-text">{{ langConfig.setting[langConfig.curLang]['ODDS_FORMAT'] }}</span>
            </div>
            <div class="setting-mode-content">
              <div class="setting-odds-form">
                <el-radio-group v-model="setting.oddsFormRadio" @change="(val) => {
                onChangeSetting(val, 'oddsFormRadio')
              }">
                  <el-radio class="sort-radio" :label="1">EU(1.50)</el-radio>
                  <el-radio class="sort-radio" :label="2">UK(1/2)</el-radio>
                  <el-radio class="sort-radio" :label="3">HK(0.50)</el-radio>
                  <el-radio class="sort-radio" :label="4">MA(0.50)</el-radio>
                  <el-radio class="sort-radio" :label="5">US(-200)</el-radio>
                  <el-radio class="sort-radio" :label="6">IN(-2.00)</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="setting-mode flex flex-v" v-if="loginInfoShow">
            <div class="setting-mode-title flex flex-align-center">
              <i class="icon-font icon-exit"></i>
              <span class="mode-text"><a class="out-login" @click="logout">{{ langConfig.login[langConfig.curLang]['LOGOUT'] }}</a></span>
            </div>
          </div>
        </div>

        <div class="pop-league-contant" v-show="screenWidth<= 767 && navTab && tab == 0">
          <MyLeague :myLeague="myLeague" />
          <HotLeague :hotLeague="hotLeague" :myLeague="myLeague" />
        </div>
      </div>
      <div class="pop-setting-mask" v-show="popSetting"></div>
    </div>
    <van-popup v-model="accountShow" class="van-popup-m"
    closeable
    close-icon="close"
    :position="screenWidth>767?'center':'bottom'" get-container="#app">
      <div class="account-pop-wrapper flex flex-v">
        <h3 class="account-title">{{ langConfig.account[langConfig.curLang]['ACCOUNT_INFO'] }}</h3>
        <div class="account-box flex flex-v flex-align-center">
          <div class="account-avtar"><img src="../assets/images/avtar.png" /></div>
          <div class="account-name">{{ login.nickname }}</div>
        </div>
        <div class="account-form flex flex-v">
          <van-form ref="form" @submit="onForgotPwdSubmit">
            <div class="account-form-item mt16 flex">
              <div class="account-form-text">{{ langConfig.account[langConfig.curLang]['EMAIL'] }}:</div>
              <div class="account-form-input"><span>{{ login.email }}</span></div>
            </div>
            <div class="account-form-item flex">
              <div class="account-form-text"><span>{{ langConfig.account[langConfig.curLang]['OLD_PASSWORD'] }}:</span></div>
              <div class="account-form-input">
                <van-field
                  v-model="account.password1"
                  name="password1"
                  :placeholder="langConfig.account[langConfig.curLang]['PLACEHOLDER_PWD1']"
                  :right-icon="account.passwordState1 ? 'eye' : 'closed-eye'"
                  :type="!account.passwordState1 ? 'password' : 'text'"
                  @click-right-icon="account.passwordState1 = !account.passwordState1"
                  :error-message="account.errorMessagePwd1"
                  @input="validatroFn(account.password1, 'pwd1')"
                />
              </div>
            </div>
            <div class="account-form-item flex">
              <div class="account-form-text"><span>{{ langConfig.account[langConfig.curLang]['NEW_PASSWORD'] }}:</span></div>
              <div class="account-form-input">
                <van-field
                  v-model="account.password2"
                  name="password2"
                  :placeholder="langConfig.account[langConfig.curLang]['PLACEHOLDER_PWD2']"
                  :right-icon="account.passwordState2 ? 'eye' : 'closed-eye'"
                  :type="!account.passwordState2 ? 'password' : 'text'"
                  @click-right-icon="account.passwordState2 = !account.passwordState2"
                  :error-message="account.errorMessagePwd2"
                  @input="validatroFn(account.password2, 'pwd2')"
                />
              </div>
            </div>
            <div class="account-form-item flex">
              <div class="account-form-text"><span>{{ langConfig.account[langConfig.curLang]['CONFIRM_PASSWORD'] }}:</span></div>
              <div class="account-form-input">
                <van-field
                  v-model="account.password3"
                  name="password3"
                  :placeholder="langConfig.account[langConfig.curLang]['PLACEHOLDER_PWD3']"
                  :right-icon="account.passwordState3 ? 'eye' : 'closed-eye'"
                  :type="!account.passwordState3 ? 'password' : 'text'"
                  @click-right-icon="account.passwordState3 = !account.passwordState3"
                  :error-message="account.errorMessagePwd3"
                  @input="validatroFn(account.password3, 'pwd3')"
                />
              </div>
            </div>
            <div class="account-form-btn">
              <van-button :disabled="account.disabled" round block type="info" native-type="submit">
                <span>{{ langConfig.login[langConfig.curLang]['SAVE'] }}</span>
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </van-popup>
    <Login :loginShow="loginShow"  @onChangePop="onChangePop" />
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { getResetPassword, getAdHits } from '@/api/api';

  import DasePicker from '@/components/basePicker.vue';
  import Login from '@/components/login.vue';
  import MyLeague from '@/components/myLeague.vue';
  import HotLeague from '@/components/hotLeague.vue';

  export default {
    components: {
      DasePicker,
      Login,
      MyLeague,
      HotLeague,
    },

    props:{
      setShow:{
        type:Array,
        default:() =>[],
      },
      tsz: {
        type: Number,
        default:0
      },
      navTab: {
        type: Boolean,
        default: false
      },
      isLogin: {
        type: Boolean,
        default: false
      },
      policy: {
        type: Boolean,
        default: true
      },
      minWidth: {
        type: Boolean,
        default: false
      },
      hotLeague: {
        type: Array,
        default: () => [],
      },
      myLeague: {
        type: Array,
        default: () => [],
      },
      ListAd: { // 广告列表
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        tab: 1,
        oddTypeArr: ['1x2', 'AH', 'O/U'],
        accountShow: false,
        loginInfoShow: false,
        loginShow: false,
        popSetting: false,
        isSetShow: true,
        login: {
          nickname: '',
          uid: 0,
          avatar: '',
          token: '',
          email: ''
        },
        setting: {
          darkSwith: false,
          soundSwith: true,
          sortRadio: 1,
          oddsType: 1,
          oddsFormRadio: 1,
          tsz: '+08:00',
        },
        svrTimestamp: 0,
        tszArr: ['-12:00','-11:00','-10:00','-09:00','-08:00','-07:00','-06:00','-05:00','-04:30','-04:00','-03:30','-03:00','-02:00','-01:00','00:00','+01:00','+02:00','+03:00','+03:30','+04:00','+05:00','+05:30','+05:45','+06:00','+06:30','+07:00','+08:00','+09:00','+10:00','+10:30','+12:00'],
        pickerList:[{
            value: '+08:00',
            name: '11.13, 22:00 , GMT+08:00'
          }],
        pickerIndex: 0,
        proceessTime: null, // 服务器时间定时器
        proceessNum: false,

        screenWidth:2000,

        account: {
          disabled: true,  // 提交是否禁用
          password1: '',
          password2: '',
          password3: '',
          errorMessagePwd1: '',
          errorMessagePwd2: '',
          errorMessagePwd3: '',
          passwordState1: false,
          passwordState2: false,
          passwordState3: false,
          pwdRxp: /[a-zA-Z0-9]{6,}/,
        },
      }
    },
    mounted(){
      if(typeof(window) != 'undefined'){
        this.screenWidth = window.innerWidth;
        this.userInfo();
        this.setCookieSetting();
        document.addEventListener('click', this.bodyClose);
        window.addEventListener('resize', this.handleResize);
      }
    },
    methods: {
      goHome(){
        this.$router.push('/');
      },

      // tab
      tabClick(val){
        let _val = val, _tab = this.common.jsonParse(this.tab);
        if(_val == _tab){
          return;
        }
        
        this.tab = _val;
      },

      // 设置按钮显示隐藏
      isSetShowFn(){
        let _setShow = this.setShow;
        if(_setShow.length > 0){
          if(_setShow.includes('news')){
            if(this.loginInfoShow){
              return true;
            }else{
              return false;
            }
          }
          return true
        }else{
          return false
        }
      },

      // 设置模块显示隐藏
      isSetModle(type){ // 时区-'timeZone', 排序-'order', 指数类型-'oddsType', 赔率格式-'oddsForm'
        let _type = type, _setShow = this.setShow;
        if(_setShow.indexOf(_type)>-1){
          return true;
        }
        return false;
      },
      // 设置弹窗
      setBtn(){
        if(!this.proceessNum){
          this.process_svrTime();
        }

        if(!this.popSetting){
          this.tzPickerArr();
          this.$nextTick(() => { // 下拉定位
            let _setting = this.common.getCookie('setting');

            if(typeof(_setting) != 'undefined' && _setting != null){
              _setting = JSON.parse(_setting);
              this.setting.tsz = _setting.tsz;
              
            }

            let _pickerList = this.common.jsonParse(this.pickerList);
            for(let item in _pickerList){
              if(_pickerList[item].value == this.setting.tsz){
                this.pickerIndex = item;
              }
            }

            this.$refs.DasePicker?.setValue(this.pickerIndex);
          });
          this.popSetting = true;
        }else{
          this.$refs.DasePicker?.closePicker();
          this.popSetting = false;
        }
        
      },

      // 时区下拉发生改变时
      changePicker(val){ 
        let _tsz = val.value, _setting = this.setting;
        _setting.tsz = _tsz;

        this.pickerIndex = val.index;

        this.common.setCookie('setting', JSON.stringify(_setting));

        this.$emit('onChangeSetting',_setting);
      }, 

      // 时区列表
      tzPickerArr(){
        let _arr = [], _tsz = this.tszArr;
        for(let i=0; i<_tsz.length; i++){
          let _tztime = this.common.getDateByArray(_tsz[i], this.svrTimestamp)
          let _date = this.common.dateStr(_tztime, 'MM.dd');
          let _time = this.common.dateStr(_tztime, 'HH:mm');
          _arr.push({
            value: _tsz[i],
            name: _date + ', '+ _time +' , GMT' + _tsz[i]
          });
        }
        this.pickerList = _arr;
      },

      // 更新服务器时间
      process_svrTime: function () {
        if(this.proceessNum){
          this.svrTimestamp += 60;
        }else{
          this.proceessNum = true;
        }

        if (typeof(this.proceessTime) == "number"){
          clearTimeout(this.proceessTime);
        }
        this.proceessTime = setTimeout(this.process_svrTime, 60000);
      },

      // 设置操作
      onChangeSetting(val, type) {
        let _setting = this.setting;

        _setting[type] = val;

        this.common.setCookie('setting', JSON.stringify(_setting));

        this.$emit('onChangeSetting',_setting);

        if(type == 'oddsFormRadio'){
          this.$emit('onChangeOddsFrom', val);
        }
        
      },

      // 登录弹窗
      showLoginPopup() {
        this.loginShow = true;
      },

      // 登录传参
      onChangePop(val) {
        let _val = val;
        this.loginShow = _val.loginShow;
        this.loginInfoShow = _val.loginInfoShow;
        this.$emit('onChangLogin', this.loginShow);
        if(this.loginInfoShow){
          this.userInfo();
        }
      },

      // 用户信息
      userInfo() {
        let _userInfo = this.common.getCookie('userInfo');
        console.log('userInfo', _userInfo)
        
        if(typeof(_userInfo) == 'undefined' || _userInfo == null){
          //console.log('no userinfo')
          return;
        }
        _userInfo = JSON.parse(_userInfo);
        _userInfo.nickname = this.common.getUserName(_userInfo.nickname);
        this.loginInfoShow = true;
        this.login.nickname = _userInfo.nickname;
        this.login.uid = _userInfo.uid;
        this.login.token = _userInfo.token;
        this.login.email = _userInfo.email;
      },

      // 退出登录
      logout() {
        this.loginInfoShow = false;
        this.login.nickname = '';
        this.login.uid = 0;
        this.login.token = '';
        this.common.delCookie('userInfo');
        location.reload();
      },

      // cookies设置
      setCookieSetting() {
        let _setting = this.common.getCookie('setting');

        if(typeof(_setting) != 'undefined' && _setting != null){
          _setting = JSON.parse(_setting);
          this.setting.darkSwith = _setting.darkSwith;
          this.setting.soundSwith = _setting.soundSwith;
          this.setting.sortRadio = _setting.sortRadio*1;
          this.setting.oddsType = _setting.oddsType*1;
          this.setting.oddsFormRadio = _setting.oddsFormRadio*1;
          this.setting.tsz = _setting.tsz;
        }
      },

      bodyClose(e) {
        if (this.$refs.setMain && !this.$refs.setMain.contains(e.target) && this.$refs.popSetMain && !this.$refs.popSetMain.contains(e.target)) {
          if (this.popSetting){
            this.$refs.DasePicker?.closePicker();
            this.popSetting = false;
          }
        }
      },

      //获取屏幕宽度
      handleResize() {
        if(typeof window!='undefined'){
          this.screenWidth = window.innerWidth;
        }
      },

      // 用户信息按钮
      accountClick() {
        if(this.accountShow){
          this.accountShow = false;
        }else{
          this.accountShow = true;
          setTimeout(() => {
            this.clearInput();
          }, 50);
        }

        this.popSetting = false;
      },

      // 用户信息修改密码
      onForgotPwdSubmit(){
        let param = {
          original_password: this.account.password1,
          password: this.account.password3,
          userToken: this.login.token
        }
        
        getResetPassword(param).then((res) => {
          this.account.disabled = false;
          let _res = res;
          if(_res.state == 200){
            Toast({
              message: this.langConfig.account[this.langConfig.curLang]['RESET_SUCCESS'],
              duration: 1000,
              onClose: () => {
                this.accountShow = false;
              }
            })
          }else{
            Toast(_res.msg);
          }
          
        }).catch((res) => {
          console.error(res)
        })
      },

      // 提交按钮是否可用
      isSubmit(){

        if(this.account.password1 != '' && this.account.password2 != '' && this.account.password3 != '' && (this.account.password2 === this.account.password3) && this.account.errorMessagePwd1 == '' && this.account.errorMessagePwd2 == '' && this.account.errorMessagePwd3 == ''){
            this.account.disabled = false;
          }else{
            this.account.disabled = true;
          }
          return;
      },

      // 清空输入框
      clearInput(){
        this.account.errorMessagePwd1 = '';
        this.account.errorMessagePwd2 = '';
        this.account.errorMessagePwd3 = '';
        this.account.password1 = '';
        this.account.password2 = '';
        this.account.password3 = '';
        this.account.passwordState1 = false;
        this.account.passwordState2 = false;
        this.account.passwordState3 = false;
        this.account.disabled = true;
        this.$refs.form.resetValidation();
      },

      // 输入框验证
      validatroFn(val, type){
        let _reg = this.account.pwdRxp;
        if(type == 'pwd1') {
          if(_reg.test(val)){
            this.account.errorMessagePwd1 = '';
            this.account.password1 = val;
            this.isSubmit();
            return true;
          }else{
            this.account.errorMessagePwd1 = this.langConfig.login[this.langConfig.curLang]['LEAST_DIGITS'];
            this.isSubmit();
            return false;
          }
        }else if(type == 'pwd2') {
          if(_reg.test(val)){
            this.account.errorMessagePwd2 = '';
            this.account.password2 = val;
            this.isSubmit();
            return true;
          }else{
            this.account.errorMessagePwd2 = this.langConfig.login[this.langConfig.curLang]['LEAST_DIGITS'];
            this.isSubmit();
            return false;
          }
        }else if(type == 'pwd3') {
          if(_reg.test(val)){
            this.account.errorMessagePwd3 = '';
            this.account.password3 = val;
            if(this.account.password2 === this.account.password3){
              this.isSubmit();
            }else{
              this.account.errorMessagePwd3 = this.langConfig.login[this.langConfig.curLang]['INCONSISTENT'];
              this.isSubmit();
            }
            return true;
          }else{
            this.account.errorMessagePwd3 = this.langConfig.login[this.langConfig.curLang]['LEAST_DIGITS'];
            this.isSubmit();
            return false;
          }
        }
      },

      // 广告点击
      adHit(id){
        let _id = id;
        let _param = {
          id: _id
        }
        getAdHits(_param);
      },

    },
    beforeDestroy() {
      if(typeof(window) != 'undefined'){
        document.removeEventListener('click', this.bodyClose);
        window.removeEventListener('resize', this.handleResize);
      }
    },

    watch:{
      'tsz':{
        immediate:true,
        handler(val){
          //console.log('弹窗时区', val)
          if(val != 0){
            this.svrTimestamp = val;
          }
        }
      },
      'isLogin': {
        immediate:true,
        handler(val){
          //console.log('登录', val)
          this.loginShow = val;
        }

      }
    }
  }
</script>

<style lang="less">
@import '~@/style/header/header.less';
</style>


// WEBPACK FOOTER //
// ./src/components/header.vue